import type { FC } from 'react';

import { Icon } from '@iconify/react';
import { Collapse, List, Tooltip } from '@mui/material';
import { sortBy } from 'es-toolkit';
import { useEffect, useState } from 'react';
import { tss } from 'tss-react/mui';

import type { GroupedTabs } from '../utils/processGroupedTabs';

import { NavMenuItem } from '../../NavMenuItem';

const useStyles = tss.create(({ theme }) => ({
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));

export const CollapsableNavGroup: FC<
  GroupedTabs & {
    titleOrder: Record<string, number>;
  }
> = ({ active, icon, tabs, title, titleOrder }) => {
  const { classes } = useStyles();
  const [open, setOpen] = useState(active);
  useEffect(() => {
    if (active) {
      setOpen(true);
    }
  }, [active]);
  return (
    <>
      <NavMenuItem
        aria-expanded={open}
        isSubmenu
        item={{ icon, title }}
        onClick={() => setOpen(prev => !prev)}
      >
        <Tooltip
          placement="right"
          title={(open ? 'Collapse ' : 'Expand ') + title}
        >
          <Icon
            fontSize={24}
            icon={
              open
                ? 'material-symbols:expand-less'
                : 'material-symbols:expand-more'
            }
          />
        </Tooltip>
      </NavMenuItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {sortBy(tabs, [
            tab => titleOrder[tab.title.toLowerCase()] ?? 9999,
          ]).map(item => (
            <NavMenuItem
              active={item.active}
              classes={{ root: classes.nested }}
              isSubmenu
              item={item}
              key={item.target}
              removeLeadingSlash
            />
          ))}
        </List>
      </Collapse>
    </>
  );
};
